import moment from "moment";

export class Range {
  start: Date | null = null;
  end: Date | null = null;
  constructor(fields?: Partial<Range>) {
    if (fields) Object.assign(this, fields);
  }
}

export type Side = "primary" | "secondary";

export interface Cell {
  day: number;
  type: "prev" | "current" | "next";
  year: number;
  month: number;
}
export interface PanelDate {
  month: number;
  year: number;
  daysInMonth: number;
  firstDay: number;
  trailing: number;
}

export class Panel {
  primary: PanelDate = {
    month: moment().month(),
    year: moment().year(),
    daysInMonth: moment().daysInMonth(),
    firstDay: 0,
    trailing: 0
  };
  secondary: PanelDate = {
    month: moment().month() + 1,
    year: moment().year(),
    daysInMonth: moment().daysInMonth(),
    firstDay: 0,
    trailing: 0
  };
}
